<template>
    <!-- home section -->
    <section
        class="home-5 tw-pt-[30px] xs:tw-mt-4"
        id="home"
        :style="{
            'background-image':
                'url(' + require('@asset/landing/img/home5-bg.png') + ')',
        }"
    >
        <!-- start container -->
        <div class="container">
            <div class="row align-items-center">
                <div class="col-lg-6">
                    <h1 class="tw-mt-6">
                        {{
                            translate(
                                "TiTi is a Free and Fast private messenger platform",
                                "TiTi is a Free and Fast private messenger platform"
                            )
                        }}
                    </h1>
                    <p class="text-muted">
                        {{
                            translate(
                                "Join TiTi and enjoy different chatting experience with special features.",
                                "Join TiTi and enjoy different chatting experience with special features."
                            )
                        }}
                    </p>

                    <LoginForm></LoginForm>

                    <!-- <div class="d-flex align-items-center mt-5">
                        <div class="flex-shrink-0">
                            <div class="more-profile d-flex">
                                <div class="avatar-sm top-child m-0">
                                    <img
                                        :src="
                                            require('../../../assets/landing/img/img-1.jpg')
                                        "
                                        alt=""
                                        class="img-fluid avatar-sm"
                                    />
                                </div>
                                <div class="avatar-sm top-child">
                                    <img
                                        :src="
                                            require('../../../assets/landing/img/img-2.jpg')
                                        "
                                        alt=""
                                        class="img-fluid avatar-sm"
                                    />
                                </div>
                                <div class="avatar-sm top-child">
                                    <img
                                        :src="
                                            require('../../../assets/landing/img/img-3.jpg')
                                        "
                                        alt=""
                                        class="img-fluid avatar-sm"
                                    />
                                </div>
                                <div class="avatar-sm top-child">
                                    <p class="f-14 mb-0">99+</p>
                                </div>
                            </div>
                        </div>
                        <div class="flex-grow-1 ms-3">
                            <h6 class="mb-0">99+ user</h6>
                            <p class="fw-semibold mb-0 text-muted">
                                Connecting all your storages together
                            </p>
                        </div>
                    </div> -->
                </div>

                <div class="col-lg-6">
                    <div class="ms-lg-5">
                        <img
                            :src="require('@asset/landing/img/home-5.png')"
                            alt=""
                            class="img-fluid"
                        />
                    </div>
                </div>
            </div>
        </div>
        <!-- end container -->
    </section>
    <!-- end home section -->
</template>

<script>
import LoginForm from "@landing/Components/LoginForm.vue";
export default {
    components: { LoginForm },
};
</script>
